<template>
  <div class="w-full">
    <!-- Mismo contenedor y ancho que las demás vistas del flujo -->
    <div class="single-window-container mx-auto px-5 sm:px-6 lg:px-8">
      <!-- Encabezado de la sección -->
      <div class="flex items-center mb-6">
        <img
          :src="trackProcessIcon"
          class="mr-2"
          :style="{ width: '28px', height: '28px' }"
          alt=""
          aria-hidden="true"
        />
        <h2 class="text-blue-dark font-bold text-lg md:text-xl m-0 pl-1">
          Preguntas orientadoras
        </h2>
      </div>

      <!-- Card contenedor -->
      <div
        class="bg-white rounded-lg shadow-sm border border-gray-200 px-5 py-8 sm:px-8 sm:py-10 md:px-16 md:py-12"
      >
        <!-- Enlace Anterior (alineado a la izquierda) -->
        <div class="text-left">
          <button
            type="button"
            class="inline-flex items-center gap-2 text-base font-semibold text-blue focus:outline-none"
            @click="onBack"
          >
            <img :src="returnIcon" class="w-5 h-4" alt="" aria-hidden="true" />
            Anterior
          </button>
        </div>

        <!-- Título de la pregunta -->
        <h2 class="mt-6 mb-3 text-left font-bold text-gray-700 leading-relaxed text-base md:text-lg">
          {{ questionLabel }}
        </h2>

        <!-- Texto guía con enlace al listado de entidades vigiladas -->
        <p class="mb-6 text-left text-gray-700 leading-relaxed text-sm md:text-base">
          Consulte el listado de entidades vigiladas por la Superintendencia haciendo
          <a
            :href="supervisedEntitiesHref"
            target="_blank"
            rel="noopener noreferrer"
            class="text-blue underline hover:text-blue-dark focus:outline-none focus:ring-2 focus:ring-blue rounded"
          >clic aquí</a>.
        </p>

        <!-- Opciones -->
        <fieldset class="flex flex-col gap-3 m-0 p-0 border-0">
          <legend class="sr-only">¿Con qué está relacionada su solicitud?</legend>

          <label
            v-for="option in options"
            :key="option.id"
            class="option-label flex items-center gap-3 px-5 py-3.5 rounded-xl border cursor-pointer transition-colors duration-200"
            :class="
              selected === option.id
                ? 'bg-blue-light border-blue'
                : 'bg-white border-blue-light hover:bg-blue-light hover:border-blue'
            "
          >
            <input
              type="radio"
              name="relates-procedure"
              class="sr-only"
              :value="option.id"
              :checked="selected === option.id"
              @change="onSelect(option.id)"
            />
            <!-- Radio personalizado. El borde/punto pasan a azul cuando la opción
                 está seleccionada o cuando el label está en hover. -->
            <span
              class="option-radio flex-shrink-0 flex items-center justify-center w-5 h-5 rounded-full border-2 transition-colors duration-200"
              :class="selected === option.id ? 'border-blue' : 'border-gray-400'"
              aria-hidden="true"
            >
              <span
                class="option-dot block w-2.5 h-2.5 rounded-full bg-blue"
                :class="{ 'opacity-0': selected !== option.id }"
              ></span>
            </span>
            <span class="text-left text-sm text-gray-700 leading-snug">
              {{ option.name }}
            </span>
          </label>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import trackProcessIcon from "@/assets/icons/question-mark.svg";
import returnIcon from "@/assets/icons/return.svg";

export default {
  name: "question_relates_procedure",
  data() {
    return {
      trackProcessIcon,
      returnIcon,
      questionLabel: "¿Con quién está relacionada la solicitud?",
      // Enlace al listado de entidades vigiladas por la Superintendencia.
      supervisedEntitiesHref:
        "https://www.superfinanciera.gov.co/publicaciones/entidades-vigiladas/",
      // Opción seleccionada. Vacío = ninguna marcada al cargar.
      selected: "",
      options: [
        {
          id: "supervised-entity",
          name: "Está relacionada con una entidad vigilada",
        },
        {
          id: "sfc",
          name: "Está relacionada con la Superfinanciera",
        },
      ],
    };
  },
  methods: {
    onSelect(value) {
      this.selected = value;

      if (value === "supervised-entity") {
        this.goToSupervisedEntity();
      } else if (value === "sfc") {
        this.goToSfc();
      }
    },
    goToSupervisedEntity() {
      // "Está relacionada con una entidad vigilada".
      this.$router
        .push("/single-window/create-procedure/question-ev-procedure")
        .catch(() => {});
    },
    goToSfc() {
      // "Está relacionada con la Superfinanciera".
      this.$router
        .push("/single-window/create-procedure/question-sfc-procedure")
        .catch(() => {});
    },
    onBack() {
      // Vuelve al paso anterior del flujo.
      this.$router
        .push("/single-window")
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
/*
 * Mismo ancho máximo del card que en las demás vistas del módulo single-window.
 */
.single-window-container {
  max-width: 960px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/*
 * Efecto hover sobre una opción no seleccionada: el radio interno también se
 * tiñe de azul (borde azul + punto visible).
 */
.option-label:hover .option-radio {
  border-color: #3366cc; /* blue.DEFAULT */
}

.option-label:hover .option-dot {
  opacity: 1;
}

.option-dot {
  transition: opacity 0.2s;
}
</style>
